/* global axios */
import ApiClient from './ApiClient';

class ConversationProductsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getProducts(conversationId) {
    return axios.get(`${this.url}/${conversationId}/products`);
  }

  addProduct(conversationId, productData) {
    const fullUrl = `${this.url}/${conversationId}/products`;
    console.log('🔄 API: Adicionando produto à conversa:', {
      baseUrl: this.baseUrl(),
      resource: this.resource,
      url: this.url,
      fullUrl,
      conversationId,
      productData,
      payload: {
        conversation_product: productData,
      },
    });
    return axios.post(fullUrl, {
      conversation_product: productData,
    });
  }

  updateProduct(conversationId, productId, productData) {
    return axios.patch(`${this.url}/${conversationId}/products/${productId}`, {
      conversation_product: productData,
    });
  }

  removeProduct(conversationId, productId) {
    return axios.delete(`${this.url}/${conversationId}/products/${productId}`);
  }
}

export default new ConversationProductsAPI();
